module.exports = __webpack_public_path__ + "media/images/capital@2x-b5f5e1ef4fef0f2ba6244112b5914bc5.png";